import { parseISO } from 'date-fns';

import type { CampaignType } from './types';

export function getEndDate(campaign: CampaignType) {
  const { endDateTime } = campaign;
  return parseISO(endDateTime ?? '');
}
